const ArrowRight = ({ width = 24, height = 24, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        d="M13.6727 12.0002L8.72266 7.05023L10.1367 5.63623L16.5007 12.0002L10.1367 18.3642L8.72266 16.9502L13.6727 12.0002Z"
        fill={color}
      />
    </svg>
  )
}

export default ArrowRight
